export default "__VITE_ASSET__47db1392__"